import { defineAction } from "rd-action-creators";

export const saveClientAction = defineAction<{}>("SAVE CLIENT ACTION");

export const uploadMappingsForCreateClient = defineAction<{}>("UPLOAD MAPPINGS FOR CREATE CLIENT");

export const changeStatusCreateClientModalAction = defineAction<{ isOpen: boolean }>(
    "CHANGE STATUS CREATE CLIENT MODAL ACTION"
);

export const changeClientSavingFlag = defineAction<{ status: boolean }>("CHANGE CLIENT SAVING FLAG ACTION");
